import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 1rem;
`;

export const Center = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: ${(props) => (props.space ? "space-between" : "center")};
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContainerPaginate = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`;

export const InputSearch = styled.div`
  width: 100%;

  button {
    background-color: var(--color-primary);
    border: none;
    padding: 5px 20px;
    cursor: pointer;
    color: #fff;
    margin-left: 5px;
    border-radius: 5px;
  }
`;

export const ButtonAction = styled.button`
  padding: 0.5rem 1rem;
  border: none;
  cursor: pointer;
  background-color: var(--color-primary);
  color: #fff;
  border-radius: 5px;
  font-weight: 600;

  &:hover {
    background-color: var(--color-primary-dark);
  }
`;

export const Description = styled.div`
  p {
    font-size: 1.2rem;
  }
`;

export const LinkContainer = styled.div`
  p {
    margin: 0;
  }
  div {
    // background-color: #ff000050;
    display: flex;
    align-items: center;

    a {
      display: block;
      padding: 10px;
      border-radius: 5px;
    }

    button {
      border: none;
      padding: 5px 10px;
      border-radius: 5px;
      background-color: #2aa306;
      color: #fff;
      font-weight: 600;
      cursor: pointer;
    }
  }
`;
